import * as React from "react";
import { useEffect, useState } from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";

interface ITakeFullValueProps {
    currentValue: number;
    maxValue: number;
    onChange: (value: number) => void;
}

export const TakeFullValue = (props: ITakeFullValueProps) => {
    const [currentValue, setcurrentValue] = useState(props.currentValue);
    const [maxValue, setmaxValue] = useState(props.maxValue);
    const [tempValue, settempValue] = useState(props.currentValue);
    const [isChecked, setisChecked] = useState(false);

    return (
        <>
            <td>
                <MoneyTextBoxEditor
                    value={currentValue}
                    currency={CurrencyCode.GBP}
                    label={""}
                    disabled={isChecked}
                    onChange={(v) => props.onChange(v)}
                    maxNumberOfDecimalPlaces={{
                        errorMessage: "only allow two decimal places",
                        value: 2,
                    }}
                    validationRules={[
                        {
                            errorMessage: "Value cannot be greater than maximum income per payment",
                            validator: (v) => v <= maxValue,
                        },
                        {
                            errorMessage: "Value can not be less than 0",
                            validator: (v) => v >= 0,
                        },
                    ]}
                />
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Take Full Value",
                            value: isChecked,
                            onChange: (v) => {
                                setisChecked(v);
                                if (v) {
                                    setisChecked(true);
                                    settempValue(currentValue);
                                    setcurrentValue(maxValue);
                                } else {
                                    setisChecked(false);
                                    settempValue(currentValue);
                                    setcurrentValue(tempValue);
                                }
                            },
                        },
                    ]}
                />
            </td>
        </>
    );
};
